import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="w-full px-12 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/dbcea1a0-86b0-419a-b784-7a681353a655.png" 
              alt="Axi AS Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className={`text-xl font-light tracking-widest transition-colors ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}>
              Axi AS
            </span>
          </div>
          <div className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-sm font-light tracking-wide transition-colors hover:opacity-70 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-light tracking-wide transition-colors hover:opacity-70 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className={`text-sm font-light tracking-wide transition-colors hover:opacity-70 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className={`text-sm font-light tracking-wide transition-colors hover:opacity-70 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-light tracking-wide transition-colors hover:opacity-70 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
    </div>
  );
}